export default __webpack_public_path__ + "08a8b04c68e0cf242d222944daed2d1f.png";